
import React from 'react'
import { ISearchAndFilterProduct, ISearchAndFilterProductImage } from '../../../../context/search/types'
import Price from '../../../Price';
import getRoute from '../../../../../scripts/utils/getRoute';
import Image from '../../../Image';
import { Swiper, SwiperSlide } from 'swiper/react';
import SearchProductStickers from './SearchProductStickers';

interface ISearchResultsProductCardComponent {
  product: ISearchAndFilterProduct,
  dataSet?: DOMStringMap,
  simple?: boolean,
  modifier?: string,
}

const SearchProductCard: React.FC<ISearchResultsProductCardComponent> = ({ product, dataSet, simple, modifier }): JSX.Element => {
  let collMainImg: ISearchAndFilterProductImage | null = null;
  // When we're using the product card on Recently Viewed/Related Products the data comes from Shopify
  // In that case the product.images is pretty useless as it it just an array of strings
  // Here we filter the media so we only get images (not videos or 3D models)
  const productImageArray: ISearchAndFilterProductImage[] = Array.isArray(product.media)
    ? (product.media as any[]).filter(media => media && media.media_type === 'image')
    : Array.isArray(product.images)
      ? product.images
      : [];
  const currCollHandle = dataSet?.currCollectionHandle ? dataSet.currCollectionHandle : null

  let mainImg: ISearchAndFilterProductImage | null = productImageArray.length > 0 ? productImageArray[0] : null;

  // If we have a collection handle then loop over the images
  if (currCollHandle) {
    for (let i = 0; i < productImageArray.length; i++) {
      const img: ISearchAndFilterProductImage = productImageArray[i];
      if(!img || !img.alt) continue
      const imgAlt: string = img.alt;
      const imgAlts = imgAlt.split(',');
      if (!currCollHandle) continue;

      const matchedHandle = imgAlts.find(alt => alt === currCollHandle)

      if (matchedHandle) {
        collMainImg = img;
        break
      }
    }
    if (collMainImg) mainImg = collMainImg;
  }

  const productHandle = product.handle ? product.handle : product.url.split('products/')[1]

  const productUrl = `${getRoute()}products/${productHandle}`

  const otherImgs: ISearchAndFilterProductImage[] = mainImg
    ? productImageArray.filter(img => img && img.src !== mainImg.src)
    : productImageArray.slice(1);



  // Global-E pricing is now handled via Contextual Pricing (Storefront API) in the data layer (mapProduct)
  // so we don't need to fetch it here or pass special props.

  return (
    <div className={`product-card product-card--react${simple ? ' product-card--simple' : ''}${modifier ? ` product-card--${modifier}` : ''}`} data-ticket={product.ticket ?? ''}>
      <div className='product-card__image-container'>
        <a href={productUrl}>
          <div className="product-card__image">
            {mainImg && mainImg.src ? (
              simple ? (
                <Image alt={mainImg.alt ?? product.title ?? ''} width={480} height={720} src={mainImg.src} className='product-card__img' />
              ) : (
                <Swiper
                  loop={true}
                >
                  {
                    productImageArray && productImageArray.length > 0 && (
                      <SwiperSlide key={mainImg.src}>
                        <Image alt={mainImg.alt ?? product.title ?? ''} width={480} height={720} src={mainImg.src} className='product-card__img' />
                      </SwiperSlide>
                    )
                  }
                  {
                    otherImgs && otherImgs.length > 0 && otherImgs.map(image => (
                      image && image.src ? (
                        <SwiperSlide key={image.src}>
                          <Image alt={image.alt ?? product.title ?? ''} width={480} height={720} src={image.src} className='product-card__img' />
                        </SwiperSlide>
                      ) : null
                    ))
                  }
                </Swiper>
              )
            ) : null}
          </div>
        </a>
        {product.meta?.stickers && product.meta.stickers.length > 0 && (
          <SearchProductStickers stickers={product.meta.stickers} />
        )}
      </div>
      <div className="product-card__info">
        <h3 className="product-card__title"><a href={productUrl}>{product.title}</a></h3>


        <div className="product-card__price">
          <Price
            finalPrice={product.priceObj ? product.priceObj.finalPrice : product.price}
            originalPrice={product.priceObj ? product.priceObj.originalPrice : product.compare_at_price ? product.compare_at_price : product.price}
            priceMin={product.priceObj ? product.priceObj.priceMin : product.price_min}
            priceMax={product.priceObj ? product.priceObj.priceMax : product.price_max}
            priceVaries={product.priceObj ? (product.priceObj.priceMin !== product.priceObj.priceMax) : (product.price_min !== product.price_max)}
          />
        </div>

      </div>
    </div>
  )
}

export default SearchProductCard
